/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />

module Eseebase {
    export class ScannedImageController implements angular.IController{
        public scannedImages: ScannedImagePagedResult;
        public filters: ModelFilterViewModel;
        public erroLoadingData: boolean;
        public isLoading: boolean;
        public fileToken: string;
        public filesToUpload: string[];
        $onInit = () => { };

        constructor(private $scope: any,
            private buildingService: BuildingService,
            private scannedImageService: ScannedImageService,
            private $q: ng.IQService,
            private $timeout: ng.ITimeoutService,
            private $mdDialog: any,
            private textService: TextService,
            private fileService: FileService
        ) {
            this.scannedImages = new ScannedImagePagedResult();
            var vm = this;
            
            fileService.getFileToken().then((token: string) => vm.fileToken = token);
            this.$scope.$on('loadScannedImages', function (e, pageNumber) {
                if (pageNumber == 1) {
                    vm.scannedImages = new ScannedImagePagedResult();
                }
                vm.loadData(pageNumber);
            });
            this.$scope.$on('scannedImageLoadMore', () => {
                if (vm.scannedImages.pageNumber > 0 && !vm.scannedImages.isLastPage) {
                    vm.loadData(vm.scannedImages.pageNumber + 1);
                }
            });
        }

        public loadData(pageNumber: number) {
            if (this.scannedImages.isLastPage || this.scannedImages.pageNumber == pageNumber || this.isLoading) {
                return;
            }
            this.isLoading = true;
            var oldPageNumber = this.scannedImages.pageNumber;
            this.scannedImages.pageNumber = pageNumber;
            this.scannedImages.totalNumberOfPages = -1;
            var vm = this;
            this.erroLoadingData = false;
            this.filters = this.buildingService.getFilters();
            this.scannedImageService.getScannedImages(this.filters, pageNumber).then((data: ScannedImagePagedResult) => {
                if (data == null || data.results == null || data.results.length == 0) {
                    vm.scannedImages.isLastPage = true;
                    vm.scannedImages.totalNumberOfPages = 0;
                    vm.isLoading = false;
                    return;
                }
                if (data.results.length < 10) {
                    vm.scannedImages.isLastPage = true;
                }
                vm.scannedImages.totalNumberOfPages = data.totalNumberOfPages;
                if (vm.scannedImages.results != null) {
                    for (var src of data.results) {
                        var isFound = false;
                        for (var dest of vm.scannedImages.results) {
                            if (dest.departmentNumber == src.departmentNumber && dest.localizer == src.localizer) {
                                dest.images = dest.images.concat(src.images);
                                isFound = true;
                                break;
                            }
                        }
                        if (!isFound) {
                            vm.scannedImages.results.push(src);
                        }
                    }
                }
                else {
                    vm.scannedImages.results = vm.scannedImages.results.concat(data.results);
                }

                if (pageNumber == 1) {
                    vm.scannedImages.totalNumberOfRecords = data.totalNumberOfRecords;
                    vm.$scope.vm.totalResultCount = data.totalNumberOfRecords;
                }
                vm.isLoading = false;
            }, () => {
                vm.erroLoadingData = true;
                vm.scannedImages.pageNumber = oldPageNumber;
                vm.isLoading = false;
            });
        }

        public showDialog(url: string, $event) {
            var vm = this;
            var dialog = {
                controller: function () {
                    this.url = url;
                    this.$mdDialog = vm.$mdDialog;
                    this.maxWidth = 200;
                    this.maxHeight = 400;
                    this.resizeWindow = function () {
                        this.maxWidth = window.innerWidth
                            || document.documentElement.clientWidth
                            || document.body.clientWidth;

                        this.maxWidth = this.maxWidth * 0.8;

                        this.maxHeight = window.innerHeight
                            || document.documentElement.clientHeight
                            || document.body.clientHeight - 70;

                        this.maxHeight = this.maxHeight * 0.7;
                    };
                    this.resizeWindow();
                    var self = this;
                    $(window).resize(() => self.resizeWindow());
                },
                controllerAs: 'vm',
                templateUrl: '/app/dialog/main-drawing.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                targetEvent: $event
            };
            this.$mdDialog.show(dialog);
        }

        public deleteImage(si: ScannedImageViewModel, image: DrawingViewModel, idx: number, $event: any) {
            var vm = this;
            var confirm = this.$mdDialog.confirm()
                .title(vm.textService.translate('ScannedImage_DeleteDrawing'))
                .textContent(vm.textService.translate('ScannedImage_DeleteConfirmation').replace(/\{0\}/g, image.fileName))
                .ariaLabel(vm.textService.translate('ScannedImage_DeleteDrawing'))
                .targetEvent($event)
                .ok(vm.textService.translate('Button_OK'))
                .cancel(vm.textService.translate('Button_Cancel'));

            this.$mdDialog.show(confirm).then(() => {
                vm.scannedImageService.deleteImage(image.id)
                    .then(() => vm.$timeout(() => {
                        si.images.splice(idx, 1);
                        if (si.images.length == 0) {
                            var indexToDelete = vm.scannedImages.results.indexOf(si);
                            vm.scannedImages.results.splice(indexToDelete, 1);
                            if (vm.scannedImages.results.length == 0) {
                                vm.scannedImages.totalNumberOfRecords = 0;
                                vm.scannedImages.totalNumberOfPages = 0;
                            }
                        }
                    }),
                          () => { });
            }, () => { });
        }

        public getFileExtension(fileName: string) {
            fileName = fileName.toLowerCase();
            return fileName.substring(fileName.length - 3);
        }

        public fileType(fileName: string) {
            var extension = this.getFileExtension(fileName);
            switch (extension)
            {
                case "png":
                case "jpg":
                    return "image";
                case "tif":
                    return "tif";
                case "pdf":
                    return "pdf";
                case "dwf":
                    return "dwf";
            }
            return "image";
        }

        public showFile(url) {
            this.scannedImageService.getPdf(url).then((r: any) => {
                var newBlob = new Blob([r.blob], { type: "application/pdf" });
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(newBlob);
                    return;
                }
                const data = window.URL.createObjectURL(newBlob);
                var link = document.createElement('a');
                link.href = data;
                link.download = "file.pdf";
                link.click();
                setTimeout(function () {
                    window.URL.revokeObjectURL(data);
                }, 100);
            });
        }

        public getUrl(image: DrawingViewModel) {
            if (image.url.indexOf('.file.') > -1) {
                return image.url + this.fileToken;
            }
            else {
                return image.url;
            }
        }

        public getPreviewUrl(image: DrawingViewModel) {
            var url = image.previewUrl;
            if (this.fileType(image.modelName) == "image" && this.getFileExtension(image.modelName) != 'jpg')
            {
                url = image.url;
            }
            if (url.indexOf('.file.') > -1) {
                return url + this.fileToken;
            }
            else {
                return url;
            }
        }

        public showSpinner() {
            var vm = this;
            var dialog = {
                templateUrl: '/app/dialog/spinner.html',
                parent: angular.element(document.body),
                clickOutsideToClose: false
            };
            this.$mdDialog.show(dialog);
            return dialog;
        }

        public onUploadStart(eventArgs: UploadEventArgs) {
            var vm = this;
            this.filesToUpload = eventArgs.fileNames;
            var spinner = this.showSpinner();
            this.scannedImageService.uploadImages(eventArgs.companyNumber,
                eventArgs.associationNumber,
                eventArgs.departmentNumber,
                eventArgs.localizer == null ? 'null' : eventArgs.localizer,
                eventArgs.formData).then((data: DrawingViewModel[]) => {
                    vm.$timeout(() => {
                        if (vm.scannedImages == null || vm.scannedImages.results == null || vm.scannedImages.results.length < 10) {
                            vm.scannedImages = new ScannedImagePagedResult();
                            vm.loadData(1);
                        }
                        else {
                            var matchingImages = this.scannedImages.results.filter(i => Number(i.associationNumber) == Number(eventArgs.associationNumber) && Number(i.departmentNumber) == Number(eventArgs.departmentNumber) && (eventArgs.localizer == null || i.localizer == eventArgs.localizer));
                            if (matchingImages != null && matchingImages.length > 0) {
                                matchingImages[0].images = matchingImages[0].images.concat(data);
                            }
                            else {
                                vm.loadData(1);
                            }
                        }
                    });
                    vm.$mdDialog.cancel();
                }, () => { vm.$mdDialog.cancel(); });
        }
    }

    ScannedImageController.$inject = ['$scope', 'BuildingService', 'ScannedImageService', '$q', '$timeout', '$mdDialog', 'TextService', 'FileService'];

    angular
        .module('eseebase')
        .controller('ScannedImageController', ScannedImageController);
}
